export const addRowNum = (data: any) => {
  return data.map((obj: any, index: number) => ({
    ...obj,
    rowNum: index + 1
  }))
}
